import { FC } from 'react';
import Heading from '../common/Heading';
import { StrapiSideBySideData } from '../section/sideBySide';
import { twMerge } from 'tailwind-merge';
import {
  TextWithDropShadowColor,
  TextWithDropShadow,
} from '../TextWithDropShadow';
import { getBackground } from '@/theme/backgrounds';
import clsx from 'clsx';

export const SideBySide: FC<{ content: StrapiSideBySideData }> = ({
  content,
}) => {
  const background = content.background;
  const padding = content.padding;
  const minHeight = content.minHeight;
  const headingLeftColor: TextWithDropShadowColor = {
    text: content.headingLeft?.color?.color || 'text-grey-900',
    shadow: 'text-grey-900',
  };

  const headingRightColor: TextWithDropShadowColor = {
    text: content.headingRight?.color?.color || 'text-grey-900',
    shadow: 'text-grey-900',
  };

  const headingLeftSize =
    (content.headingLeft?.text &&
      content.headingLeft.size?.size.match(/\d+/)?.[0]) ||
    '4';

  const headingRightSize =
    (content.headingRight?.text &&
      content.headingLeft.size?.size.match(/\d+/)?.[0]) ||
    '4';

  const bodyLeftColor: TextWithDropShadowColor = {
    text: content.bodyLeft?.color?.color || 'text-grey-900',
    shadow: 'text-grey-900',
  };

  const bodyRightColor: TextWithDropShadowColor = {
    text: content.bodyRight?.color?.color || 'text-grey-900',
    shadow: 'text-grey-900',
  };

  const backgroundStyle = background?.url
    ? {
        backgroundImage: `url(${background.url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    : {
        background:
          background?.style && getBackground(content.background.style),
      };

  const paddingClass =
    padding &&
    `p-0 pt-${padding.top} pr-${padding.right} pb-${padding.bottom} pl-${padding.left} `;

  const heightClass = minHeight ? `min-${minHeight.value}` : '';

  const titleColor: TextWithDropShadowColor = {
    text: content.title?.color?.color || 'text-grey-900',
    shadow: 'text-grey-900',
  };

  const titleSize =
    (content.title?.text && content.title?.size?.size.match(/\d+/)?.[0]) || '4';

  return (
    <>
      <div
        style={backgroundStyle}
        className={twMerge(
          'container-safe-reliable mx-auto w-full max-w-screen-2xl',
          clsx(paddingClass),
          clsx(heightClass),
          content.rounded && 'rounded-3xl'
        )}
      >
        <div className='mx-auto mb-9 w-full text-center md:w-8/12'>
          <Heading size={`${titleSize}`}>
            <TextWithDropShadow
              text={content.title?.text}
              color={titleColor}
              displayShadow={content.title?.shadow}
            ></TextWithDropShadow>
          </Heading>
        </div>
        <div className='flex flex-row flex-wrap justify-center'>
          <div
            className={`flex w-full flex-col gap-y-4 border-b border-r-0 border-gray-300 px-12 py-6 text-center  ${content.orientation === 'side-by-side' ? 'sm:w-1/2 sm:border-b-0 sm:border-r ' : ''}`}
          >
            <Heading size={`${headingLeftSize}`}>
              <TextWithDropShadow
                text={content.headingLeft?.text}
                color={headingLeftColor}
                displayShadow={content.headingLeft?.shadow}
              />
            </Heading>
            <div className={twMerge('text-lg font-normal', bodyLeftColor.text)}>
              {content.bodyLeft?.text}
            </div>
          </div>
          <div className='flex w-full flex-1 flex-col gap-y-4 px-12 py-6 text-center sm:w-1/2'>
            <Heading size={`${headingRightSize}`}>
              <TextWithDropShadow
                text={content.headingRight?.text}
                color={headingRightColor}
                displayShadow={content.headingRight?.shadow}
              />
            </Heading>
            <div
              className={twMerge('text-lg font-normal', bodyRightColor.text)}
            >
              {content.bodyRight?.text}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
